import React from "react";
import { motion } from "framer-motion";
import { TOTAL_COUNTRIES, TOTAL_DESTINATIONS } from "@/data/destinations";

const HERO_IMG =
  "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?w=2400&q=85";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100vh] w-full overflow-hidden"
    >
      <img
        src={HERO_IMG}
        alt="Overwater luxury villa at sunset"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 hero-vignette" />
      <div className="grain" />

      <div className="relative z-10 max-w-[1440px] mx-auto px-6 sm:px-12 lg:px-20 pt-40 pb-24 min-h-[100vh] flex flex-col justify-between">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-4xl"
          data-testid="hero-headline"
        >
          <div className="flex items-center gap-4 mb-8 text-white/80 text-[11px] tracking-[0.32em] uppercase">
            <span>Vol. I</span>
            <span className="w-8 h-px bg-white/40" />
            <span>The 2026 Catalog</span>
          </div>
          <h1 className="font-display text-white text-6xl sm:text-7xl lg:text-[112px] leading-[0.92] tracking-tighter font-light">
            <span className="italic">130+</span> Destinations.
            <br />
            Choose your
            <br />
            <span className="italic">luxury</span> stay.
          </h1>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 1 }}
          className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 items-end text-white"
        >
          <p className="max-w-md text-sm sm:text-base leading-relaxed text-white/85 font-light">
            A private catalog of {TOTAL_DESTINATIONS}+ curated stays across{" "}
            {TOTAL_COUNTRIES} countries. Submit your details to receive the full
            brochure and further instructions from your sourcing specialist.
          </p>

          <div className="hidden md:flex flex-col gap-1 border-l border-white/25 pl-8">
            <span className="font-display text-5xl leading-none">
              {TOTAL_DESTINATIONS}+
            </span>
            <span className="text-[10px] uppercase tracking-[0.32em] text-white/60">
              Curated Stays
            </span>
          </div>

          <div className="flex items-center justify-start md:justify-end gap-6">
            <a
              href="#reserve"
              data-testid="hero-reserve-button"
              className="inline-flex items-center gap-3 px-8 py-4 bg-white text-aio-ink hover:bg-aio-bg transition-colors text-sm uppercase tracking-[0.22em]"
            >
              Request Brochure
              <span aria-hidden>&rarr;</span>
            </a>
            <a
              href="#catalog"
              data-testid="hero-catalog-link"
              className="hidden sm:inline text-xs uppercase tracking-[0.28em] text-white/70 hover:text-white"
            >
              View Catalog
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
